import { render, staticRenderFns } from "./StudentsCrudFiles.vue?vue&type=template&id=083d2248&"
import script from "./StudentsCrudFiles.vue?vue&type=script&lang=js&"
export * from "./StudentsCrudFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports